import scProductTable from '../components/ScProductTable'
let supply_chain = {
  components: {scProductTable}
}
export default supply_chain



// WEBPACK FOOTER //
// ./src/supplychain/js/supply_chain.js